import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Button,
    NavItem
} from 'reactstrap';
import {setFlowKey} from "../../../store/actions/display";
import PolyUtil from "../../../util/PolyUtil";

class PolyFlowNavItem extends Component {
    content = () => {
        const {active, label, filled, disabled} = this.props;
        return (
            <div>
                <NavItem onClick={() => {
                    if (!disabled) {
                        this.props.setFlowKey(this.props.id, this.props.itemKey);
                    }
                }} className={active ? "app-nav-item-container animated infinite pulse" : "app-nav-item-container"} style={{opacity: (active || filled) && '1', minWidth: '7em'}}>
                    <Button className='app-nav-item'
                            style={{backgroundColor: filled ? '#0082c6' : (active && '#0082c6')}}
                            disabled={disabled}/><br/>
                    <small>{label}</small>
                </NavItem>
            </div>
        );
    };

    render() {
        return PolyUtil.polyRender(this.props, ['flowKey'], this.content, null);
    }
}

const mapStateToProps = (state, props) => ({
    flowKey: state.display.flowKeys.find(key => key.id === props.id)
});

const mapDispatchToProps = (dispatch) => ({
    setFlowKey(id, value) {
        dispatch(setFlowKey(id, value));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PolyFlowNavItem);


// WEBPACK FOOTER //
// ./src/components/flow/PolyFlow/PolyFlowNavItem.js